import React, { useContext, useEffect, useMemo, useRef, useState } from "react";

import styles from "./Main.module.css";

import { Button, Checkbox, Form, Input, Menu, notification } from "antd";
import { AppContext } from "../App.context";
import axios from "axios";
import {
  checkEmpty,
  createUserApi,
  getUsers,
  isAdmin,
  pathRoutes,
} from "../service/util.service";
import { useNavigate } from "react-router-dom";
import PrivateRoute from "../menu/PrivateRoute";
import MenuTop from "../menu/MenuTop";
import MenuLett from "../menu/Menu";
import LoadingCenterSpinSmall from "./LoadingCenterSpinSmall";

function SelectUser(props) {
  return (
    <>
      <MenuLett />
      <div className={styles.boxMain}>
        <MenuTop />
        <Content />
      </div>
    </>
  );
}
function Content(props) {
  const appContext = useContext(AppContext);
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  // const [usernameCreate, setusernameCreate] = useState(null);
  // const [passwordCreate, setpasswordCreate] = useState(null);
  // const [conpasswordCreate, setconpasswordCreate] = useState(null);
  const [loadingcreate, setloadingcreate] = useState(false);

  const loaderData = async () => {
    try {
      let usersTemp = await getUsers();
      // console.log("users", users);
      setUsers(Object.assign([], usersTemp));
    } catch (e) {}
  };

  useEffect(() => {
    if (!isAdmin()) {
      navigate(pathRoutes.main);
    }
    loaderData();
  }, []);

  const setUserToSumary = (username) => {
    appContext.setAcUsername(username);
    navigate(pathRoutes.summary);
  };

  const [api, contextHolderDone] = notification.useNotification();

  const openNotificationWithIcon = (type, title, message) => {
    api[type]({
      message: title,
      description: message,
    });
  };
  const onFinishCreate = async (values) => {
    let usernameCreate = values.username?.trim();
    let passwordCreate = values.password?.trim();
    let conpasswordCreate = values.conPassword?.trim();
    if (
      checkEmpty(usernameCreate) ||
      checkEmpty(passwordCreate) ||
      checkEmpty(conpasswordCreate)
    ) {
      openNotificationWithIcon("warning", "ผู้ใช้", "กรุณาใส่ข้อมูลให้ครบ");
      return;
    }
    if (passwordCreate != conpasswordCreate) {
      openNotificationWithIcon("warning", "ผู้ใช้", "กรุณาใรหัสไม่ตรงกัน");
      return;
    }
    try {
      let body = {
        username: usernameCreate,
        password: passwordCreate,
      };
      await createUserApi(body);
      loaderData();
      openNotificationWithIcon("success", "ผู้ใช้", "สร้างนี้สำเร็จ");
    } catch (e) {
      openNotificationWithIcon("error", "ผู้ใช้", "สร้างไม่สำเร็จ");
    }
  };

  return (
    <div className={styles.box100}>
      <div style={{ paddingTop: "70px" }}>
        {/* <h1>SelectUser</h1> */}
        <div>
          {users.map((user) => {
            return (
              <div
                className={styles.boxuserSelect}
                onClick={() => {
                  setUserToSumary(user.username);
                }}
              >
                {user.username}
              </div>
            );
          })}
        </div>

        <div style={{ fontWeight: "bold", fontSize: "18", padding: "50px" }}>
          สร้างผู้ใช้
        </div>
        <div>
        <Form
            name="basic"
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            // style={{ width:"60%" }}
            // initialValues={{ remember: true }}
            onFinish={onFinishCreate}
            // onFinishFailed={onFinishFailed}
            autoComplete="off"
            className={styles.formcreateuser}
          >
            <Form.Item
              className={styles.boxInput}
              label="Username"
              name="username"
              rules={[{ required: true, message: "username" }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Password"
              name="password"
              rules={[{ required: true, message: "ใส่รหัส" }]}
            >
              <Input.Password />
            </Form.Item>
            <Form.Item
              className={styles.boxInput}
              label="Confirm-Password"
              name="conPassword"
              rules={[{ required: true, message: "ใส่ยืนยันรหัส" }]}
            >
              <Input.Password />
            </Form.Item>

            <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
              <Button type="primary" htmlType="submit">
                {loadingcreate ? <LoadingCenterSpinSmall /> : "เพิ่มผู้ใช้"}
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
      {contextHolderDone}
    </div>
  );
}
export default SelectUser;
